import React from "react";
import Breadcrumb from "../Breadcrumb";
import Heading from "../../atoms/Heading";
import EventInfoBlock from "../EventInfoBlock";
import ButtonGroup from "../ButtonGroup";

import "./hero-banner-content.m.css";

const HeroBannerContent = ({
  breadcrumbs,
  title,
  eventInfo,
  buttons,
  isMobile,
  storyUrl,
  ...props
}) => {
  return (
    <div styleName="hero-banner-content" {...props}>
      <div styleName="top-section">
        {breadcrumbs && <Breadcrumb items={breadcrumbs} />}
        <Heading variant={isMobile ? "mobile" : "desktop"}>{title}</Heading>
      </div>

      <div styleName="bottom-section">
        {eventInfo?.label || eventInfo?.title || eventInfo?.details ? (
          <EventInfoBlock
            title={eventInfo?.title}
            details={eventInfo?.details}
            storyUrl={storyUrl}
            storyTemplate={eventInfo?.storyTemplate}
            eventForum={eventInfo?.eventForum}
            eventWhen={eventInfo?.eventWhen}
          />
        ) : null}
        {buttons && <ButtonGroup buttons={buttons} />}
      </div>
    </div>
  );
};

export default HeroBannerContent;